import type {ReactNode} from 'react'
import type React from 'react'

interface OnboardingCompletionFlowProps {
  children: ReactNode
}

const OnboardingCompletionFlow: React.FC<OnboardingCompletionFlowProps> = ({children}) => {
  return <>{children}</>
}

export default OnboardingCompletionFlow
